import React, { useEffect, useState } from "react";
import { studentFeeTransactionList } from "../api/Student";
import { formatDate, SweetAlertShow } from "./master/Master";
import { Link } from "react-router-dom";

export default function TodayCollectionModal() {
    const [collection, setCollection] = useState({});
    const [page, setPage] = useState(1);

    const paymentDate = new Date().toISOString().split("T")[0];

    const getTodayCollection = async () => {
        const addUrl = `&start_date=${paymentDate}&end_date=${paymentDate}&page=${page}`;

        try {
            const response = await studentFeeTransactionList(addUrl);

            if (response?.data?.status) {
                setCollection(response?.data?.data);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message
            );
        }
    };

    useEffect(() => {
        getTodayCollection();
    }, [page]);

    return (
        <div
            className="modal fade"
            id="todayCollection"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="d-flex justify-content-between">
                            <h4 className="text-primary">Today Collection</h4>
                            <button
                                className="btn btn-sm btn-outline-primary mt-3 mb-3"
                                data-bs-dismiss="modal"
                            >
                                close
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover text-nowrap align-middle">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Student</th>
                                        <th>Receipt</th>
                                        <th>Module</th>
                                        <th>Amount</th>
                                        <th>Payment</th>
                                        <th>Bank</th>
                                        <th>Date</th>
                                        <th>Created By</th>
                                        <th>Remark</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {collection?.data?.length > 0 ? (
                                        collection?.data?.map((item, i) => (
                                            <tr key={item?.id}>
                                                <td>{i + 1}</td>

                                                <td>
                                                    <Link
                                                        to={`/student/details?id=${item?.student?.id}`}
                                                        className="fw-semibold"
                                                    >
                                                        {item?.student?.name}
                                                        <br />({item?.student?.registration_no})
                                                    </Link>
                                                </td>

                                                <td>{item?.receipt_no}</td>

                                                <td>
                                                    {(() => {
                                                        try {
                                                            const parsed = JSON.parse(item?.module);

                                                            return parsed.map((m, i) => (
                                                                <div
                                                                    key={i}
                                                                    className="text-nowrap fw-semibold"
                                                                >
                                                                    {m.type} - ₹{m.amount}
                                                                </div>
                                                            ));
                                                        } catch (e) {
                                                            return "-";
                                                        }
                                                    })()}
                                                </td>

                                                <td className="fw-bold text-success">
                                                    ₹{item?.amount}
                                                </td>

                                                <td>
                                                    <span
                                                        className={`badge ${item?.payment_method === "Cash"
                                                            ? "bg-success"
                                                            : "bg-primary"
                                                            }`}
                                                    >
                                                        {item?.payment_method}
                                                    </span>
                                                </td>

                                                <td>{item?.bank?.account_no || "-"}</td>

                                                <td>{formatDate(item?.payment_date)}</td>

                                                <td>{item?.created_by?.name || "-"}</td>

                                                <td>{item?.remark || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <nav aria-label="Page navigation" className="mt-10">
                                <p>
                                    Showing {collection?.from} to {collection?.to} of{" "}
                                    {collection?.total} entries
                                </p>
                                <ul className="pagination pagination-sm">
                                    {collection?.links?.map((btn, i) => (
                                        <li
                                            className={`page-item  ${btn?.active && "active"}  ${btn?.url ? "" : "disabled"
                                                } `}
                                        >
                                            <button
                                                className="page-link waves-effect"
                                                onClick={() => {
                                                    if (collection?.links?.length === i + 1) {
                                                        btn?.url && setPage(collection?.current_page + 1);
                                                    } else if (i === 0) {
                                                        btn?.url && setPage(collection?.current_page - 1);
                                                    } else {
                                                        setPage(btn.label);
                                                    }
                                                }}
                                            >
                                                {collection?.links?.length == i + 1 ? (
                                                    <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                                ) : i == 0 ? (
                                                    <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                                ) : (
                                                    btn?.label
                                                )}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}